/* unplugin-vue-components disabled */import { render } from "./MenuItem.vue?vue&type=template&id=91390d4e"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"

import exportComponent from "E:\\projects\\internation-fta-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__